import React from 'react';
import loader from './loader.gif';
import './Spinner.css';

export default function({ isLoading }) {
    return (isLoading)
        ? <div className="Spinner"><img alt="Loading" src={loader} /></div>
        : null;
}